import React from "react";

export const HeaderBottomSvg = () => {
  return (
    <svg
      width="100%"
      height="49"
      viewBox="0 0 1058 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M301.257 49L0.777466 49C58.9282 48.9999 78.3943 35.167 96.6411 22.2007C112.736 10.7632 127.883 -2.67026e-05 167.794 -2.67026e-05L301.257 -3.4332e-05L890.761 -3.43322e-05C930.672 -3.43322e-05 945.818 10.7632 961.914 22.2007C980.16 35.167 999.627 48.9999 1057.78 49L757.298 49L301.257 49Z"
        fill="white"
      />
    </svg>
  );
};
